import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ModalHeader, Modal, ModalBody } from "reactstrap";
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar'
import { API_URL } from '../../../config';
import right from '../../images/right.png'
import { data } from 'jquery';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const UploadNewTutorialRecording = () => {
  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const [recordingType, setRecordingType] = useState('');
  const [distributorList, setDistributorList] = useState('');
  const [zoomLink, setZoomLink] = useState('');
  const [recordingVideo, setRecordingVideo] = useState('');
  const [recordingName, setRecordingName] = useState('');
  const [categoryList, setCategoryList] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate()
  const [recordingNameErr, setRecordingNameErr] = useState(false);
  const [recordingTypeErr, setRecordingTypeErr] = useState(false);
  const [distributorListErr, setDistributorListErr] = useState(false);
  const [zoomLinkErr, setZoomLinkErr] = useState(false);
  const [recordingVideoErr, setRecordingVideoErr] = useState(false);
  const [errMessage, setErrMessage] = useState('')
  const video = useRef()
  const [sendData, setSendData] = useState();
  const [upcomingRecording, setUpcomingRecording] = useState('');
  const [show, setShow] = useState(id ? true: false);
  const [statusFieldErr, setStatusFieldErr] = useState(false);
  const [statusField, setStatusField] = useState('')
  const [downloaderModal, setDownloaderModal] = useState(false);
    const DownloaderToggleModal = () => setDownloaderModal(!downloaderModal);





  useEffect(() => {
    getCategoryList()
    if (id) {
      getTutorialList();

    }

  }, [])

  const getTutorialList = () => {
    fetch(API_URL + "/get/tutorial/recording/by/" + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setRecordingName(resp.data[0].recording_name)
          setDistributorList(resp.data[0].category_id)
          setStatusField(resp.data[0].status)
          if (resp.data[0].recording_type == 1) {
            setRecordingType(resp.data[0].recording_type)
            setZoomLink(resp.data[0].recording)

          } else if (resp.data[0].recording_type == 2) {
            setRecordingType(resp.data[0].recording_type)
            setUpcomingRecording(resp.data[0].recording)
            setRecordingVideo(resp.data[0].recording)

          }

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const getCategoryList = () => {
    fetch(API_URL + "/get/all/category",
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setCategoryList(resp.data)

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const handleRecordingType = (e) => {
    setRecordingType(e.target.value)
    setRecordingTypeErr(false)

  }
  const handleDistributorList = (e) => {
    setDistributorList(e.target.value)
    setDistributorListErr(false)

  }
  const createProfile = () => {
    if(isValid()){
    if (recordingType == 1) {
      rowData();
    } else if (recordingType == 2) {
      formData();
    }
  }else{
    return true
    
  }

  }
  const rowData = () => {
    setDownloaderModal(true)
    let data = {};
    data['recording_name'] = recordingName;
    data['category_id'] = distributorList;
    data['recording_type'] = recordingType;
    data['recording'] = zoomLink;

    fetch(API_URL + "/create/tutorial/recording/data", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data)
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function () { navigate('/edit-tutorial-recordings') }, 5000);

        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  
  }
  const UpdateRowData = () => {
    setDownloaderModal(true)
    let data = {};
    data['recording_name'] = recordingName;
    data['category_id'] = distributorList;
    data['recording_type'] = recordingType;
    if(recordingVideo == upcomingRecording && recordingType == 2){
      data['recording'] = recordingVideo;
     }else{
      data['recording'] = zoomLink 
     } 
    data['status'] = statusField;

    fetch(API_URL + "/update/tutorial/recording/by/" + id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data)
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function () { navigate('/edit-tutorial-recordings') }, 5000);

        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  
  }
  const formData = () => {
    setDownloaderModal(true)
const formData = new FormData();
formData.append('recording_name', recordingName);
formData.append('category_id', distributorList);
formData.append('recording_type', recordingType);
formData.append('form', recordingVideo);

const boundary = '---------------------------974767299852498929531610575';
const headers = {
  'Content-Type': `multipart/form-data;`
};


fetch(API_URL + "/create/tutorial/recording/data", {
  method: 'POST',
  body: formData,
  // headers: headers  
})
  .then((response) => {
    if (response.status === 200) {
      response.json().then((resp) => {
        setDownloaderModal(false)
        successToggleModal();
        setTimeout(function () { navigate('/edit-tutorial-recordings') }, 5000);
      });
    } else if (response.status === 400) {
      // Handle other status codes
    } else if (response.status === 401) {
      logout();
    } else {
      console.log("Network error");
    }
  })
  .catch((error) => {
    console.log("Error:", error);
  });

  }
  const UpdateFormData = () => {
    setDownloaderModal(true)
const formData = new FormData();
formData.append('recording_name', recordingName);
formData.append('category_id', distributorList);
formData.append('recording_type', recordingType);
formData.append('form', recordingVideo);
formData.append('status', statusField);

fetch(API_URL + "/update/tutorial/recording/by/" + id, {
  method: 'PUT',
  body: formData  
})
  .then((response) => {
    if (response.status === 200) {
      response.json().then((resp) => {
        setDownloaderModal(false)
        successToggleModal();
        setTimeout(function () { navigate('/edit-tutorial-recordings') }, 5000);
      });
    } else if (response.status === 400) {
      // Handle other status codes
    } else if (response.status === 401) {
      logout();
    } else {
      console.log("Network error");
    }
  })
  .catch((error) => {
    console.log("Error:", error);
  });

  }


  const updateProfile = () => {
    if(isValid()){
      if(recordingType == 1){
      UpdateRowData();
    }else if(recordingType == 2){
      if(recordingVideo == upcomingRecording){
        UpdateRowData()
      }else{
    UpdateFormData()
      } 
    }
  }else{
    return false
  }

  }
  const handleGoBack = () => {
    if (id) {
      navigate('/edit-tutorial-recordings');
    } else {
      navigate('/tutorial-recordings');
    }
  }
  const handleFileUpload = (event) => {
    if(event == null){
      return false;
    }else{
    const file = event;
  
    if (file) {
      let fileName = '';
      {id && recordingVideo == upcomingRecording ? fileName = file: fileName = file.name}
      // const fileName = file.name;
      const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      const isVideo = ['mp4', 'avi', 'mov', 'mkv'].includes(extension);
  
      if (isVideo) {
        return true
      } else {
        return false
      }
    }
  }
  };
  const isValid = () => {
    if (recordingName == '' && recordingType == '' && distributorList == ' ') {
      setRecordingNameErr(true)
      setRecordingTypeErr(true)
      setDistributorListErr(true)
      setErrMessage("Field required")
    } else if (recordingName.trim() == '') {
      setRecordingNameErr(true)
      setRecordingTypeErr(false)
      setDistributorListErr(false)
      setErrMessage("Field required")
      return false
    } else if (distributorList == '') {
      setRecordingNameErr(false)
      setRecordingTypeErr(false)
      setDistributorListErr(true)
      setErrMessage("Field required")
      return false
    }
    else if (recordingType == '') {
      setRecordingNameErr(false)
      setRecordingTypeErr(true)
      setDistributorListErr(false)
      setErrMessage("Field required")
    } else if (recordingType == '1' && zoomLink.length != 0) {
      if (isZoomLinkValid(zoomLink)) {
        return true
      } else {
        setRecordingNameErr(false)
        setRecordingTypeErr(false)
        setDistributorListErr(false)
        setZoomLinkErr(true)
        setRecordingVideoErr(false)
        setErrMessage("Enter valid link")
        return false
      }
    }else if (recordingType == '1' && zoomLink.length == 0) {
      setRecordingNameErr(false)
      setRecordingTypeErr(false)
      setDistributorListErr(false)
      setZoomLinkErr(true)
      setRecordingVideoErr(false)
      setErrMessage("Field required")
      return false
    }
    else if(recordingType== '2'){
      // if(recordingVideo.length==0){
      if(recordingVideo!=null && !id && recordingVideo !=upcomingRecording && upcomingRecording){
        setRecordingNameErr(false)
        // setIsDistributorErr(false)
        setDistributorListErr(false)
        setRecordingTypeErr(false)
        setZoomLinkErr(false)
        setRecordingVideoErr(true)
        setErrMessage("Field required")
      }else{
        if(handleFileUpload(recordingVideo) && id && show ){
          setRecordingVideo(upcomingRecording)
          return true
        }else  if(handleFileUpload(recordingVideo) && !show){
          setRecordingVideo(upcomingRecording)
          setUpcomingRecording('');
          return true
        }else if(recordingVideo == '' || recordingVideo == null && !show){
          setRecordingNameErr(false)
          // setIsDistributorErr(false)
          setDistributorListErr(false)
          setRecordingTypeErr(false)
          setZoomLinkErr(false)
          setRecordingVideoErr(true)
          setErrMessage("Field required")
        }else{
          setRecordingNameErr(false)
          // setIsDistributorErr(false)
          setDistributorListErr(false)
          setRecordingTypeErr(false)
          setZoomLinkErr(false)
          setRecordingVideoErr(true)
          setErrMessage("Choose valid file")
        return false
        }
      }
    }else if(id && statusField == ''){
      setRecordingNameErr(false)
      setRecordingTypeErr(false)
      setDistributorListErr(false)
      setZoomLinkErr(false)
      setRecordingVideoErr(false)
      setStatusFieldErr(true);
      setErrMessage("Field required")
      return false
    }
    return true

  }

  function isZoomLinkValid(link) {
    const zoomLinkRegex = /^https:\/\/[a-z0-9-]+\.zoom\.us\/j\/\d+\?pwd=[A-Za-z0-9-]+$/;
  
    if (zoomLinkRegex.test(link)) {
      return true
    } else {
      return false
    }
  }
  const recodingVideoCheck = (event) => {
    setRecordingVideoErr(false)
    setRecordingVideo(event.target.files[0])
  }
  const handleCloseLink = () =>{
    // setUpcomingRecording('');
    setRecordingVideo('')
    setShow(false)
  
  }
  return (
    <div>
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section ">
          <div className="head-listing head-listingb">
            <h3>{id ? "Edit Tutorial Recording " : "Upload Tutorial Recording"}</h3>
          </div>
          <div className='right-section-box'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Tutorial Recording Name*</label>
                  <input type="text" value={recordingName} onChange={(e) => {setRecordingName(e.target.value);setRecordingNameErr(false)}} className='client-input' placeholder='Enter tutorial recording name' />
                  {recordingNameErr ? <div className='linkError'>{errMessage}</div> : ""}
                </div>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                    Category Name*</label>
                  <select value={distributorList} onChange={handleDistributorList} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Category</option>
                    {
                      categoryList.length > 0 &&
                      categoryList?.map((item) => {
                        return (
                          <option value={item.id} >{item.category_name}</option>
                        )
                      })
                    }
                  </select>
                  {distributorListErr ? <div className='linkError'>{errMessage}</div> : ""}
                </div>
              </div>
            </div>

            <div className='col-lg-12'>
              <div className='row'>

                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                    Recording*</label>
                  <select value={recordingType} onChange={handleRecordingType} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Recording Type</option>
                    <option value="1">Link</option>
                    <option value="2">Video</option>
                  </select>
                  {recordingTypeErr ? <div className='linkError'>{errMessage}</div> : ""}
                </div>

                {recordingType == 1 && <div className='form-group col-lg-12 no-padding'>
                  <label className='control-label'>Zoom Link*</label>
                  <input type="text" value ={zoomLink} onChange={(e) => {setZoomLink(e.target.value);setZoomLinkErr(false)}} className='client-input' placeholder='https://zoom.us/j/1234567890' />
                  {zoomLinkErr ? <div className='linkError'>{errMessage}</div> : ""}
                </div>}
                {recordingType == 2 && <div className='form-group col-lg-12 no-padding'>
                  <label className='control-label'>Recording Video*</label>
                  <input type="file" onChange={recodingVideoCheck} className='client-input' placeholder='Enter link' />
                  {
                    id && show && upcomingRecording.length>0&& upcomingRecording !== '' ? <div style={{display:'flex',marginTop: "20px"}}><label className='control-label'>Browser link : </label><p  className='view-recording' target="_blank" onClick={()=>handleButtonClick(upcomingRecording)}>{upcomingRecording}</p><HighlightOffIcon style={{color:'blue', marginLeft:'5px', cursor:'pointer'}} onClick={handleCloseLink}/></div>: ""
                    
                  }
                  {recordingVideoErr ? <div className='linkError'>{errMessage}</div> : ""}
                </div>}
                {id ? <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Status*</label>
                  <select value={statusField} onChange={(e)=>setStatusField(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Status</option>
                    <option value="1" selected={statusField == 1 ? "Selected": ''}>Active</option>
                    <option value="0" selected={statusField == 0 ? "Selected": ''}>Inactive</option>
                  </select>
                  {statusFieldErr ? <div className='linkError'>{errMessage}</div>:""}
                 </div>:''}
              </div>
            </div>

            {/* ======5====== */}
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>

                  {id ? <button type="submit" className='btn btn-primary_d' onClick={updateProfile}>Update
                  </button> :
                    <button type="submit" className='btn btn-primary_d' onClick={createProfile}>Create
                    </button>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={downloaderModal} toggle={DownloaderToggleModal} className="connect-box" centered={true}>
                            <ModalHeader toggle={DownloaderToggleModal}><span className="ml-1 roititle font-weight-bold">Request processing...</span></ModalHeader>
                            <ModalBody>
                            <div className="modal-p">
                                <p className='text-center'>Please wait...</p>
                                <div v-if="loading" className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>
      </div>
                            </ModalBody>

                        </Modal>
      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            <h4>{id ? "Updated" : "Created"}</h4>
            <p>Tutorial recording  has been {id ? "updated" : "created"} successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </div>
  );
};

export default UploadNewTutorialRecording;

